import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { ControlUser } from './controlUser';


export class ControlUserInstallation extends BaseModel implements Deserializable {

  public DEVICE_TYPE: string = "WebAdmin";

  id: number;
  userUid: string;
  user: ControlUser;
  deviceType: string = this.DEVICE_TYPE;
  deviceUid: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    this.user = new ControlUser().deserialize(this.user);

    return this;
  }
  
}
